import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

import Chip from 'shared/atoms/Chip';
import DragAndDrop from 'shared/molecules/DragAndDrop';
import ItemBox from 'shared/molecules/ItemBox';
import theme from 'shared/themes/default';
import { newSelectTranslation } from 'shared/utils';

import { usePlaylist } from '../../../../../../context';

const DragAndDropWrapper = styled.div`
  max-height: 600px;
  overflow-y: auto;
`;

const PlaylistContentItemList = ({ menuItems, playlistContent }) => {
  const [playlistContentItems, setPlaylistContentItems] = useState([]);
  const { t } = useTranslation();

  const {
    canManagePlaylists,
    hasSubscription,
    locale,
    staticImagesHostname,
    playlists: { playlistContentOrderHandler },
  } = usePlaylist();

  useEffect(() => {
    setPlaylistContentItems(playlistContent);
  }, [playlistContent]);

  const handleDragEnd = (array) => {
    setPlaylistContentItems(array);
    if (playlistContentOrderHandler) {
      playlistContentOrderHandler(array);
    }
  };

  const isSortable = canManagePlaylists && hasSubscription;

  const renderItem = (item) => {
    const thumbnailUrl = item.thumbnail?.file?.key
      ? `${staticImagesHostname}/${item.thumbnail.file.key}`
      : null;

    return (
      <ItemBox
        id={item.id}
        draggable={isSortable}
        menuItems={menuItems}
        theme="light"
        title={newSelectTranslation(item.name, locale)}
        thumbnailIcon={!thumbnailUrl ? PlayArrowIcon : null}
        thumbnailImgSrc={thumbnailUrl}
        topTag={
          (item.daysLeft || item.daysLeft === 0) && (
            <Chip
              color={theme.palette.errorLight}
              icon={<AccessAlarmIcon />}
              label={t('courses.daysLeft', { count: item.daysLeft })}
              small
              theme="dark"
            />
          )
        }
      />
    );
  };

  return (
    <DragAndDropWrapper>
      <DragAndDrop
        isLocked={!isSortable}
        items={playlistContentItems}
        onDragEnd={handleDragEnd}
        renderItem={renderItem}
      />
    </DragAndDropWrapper>
  );
};

PlaylistContentItemList.propTypes = {
  menuItems: PropTypes.array.isRequired,
  playlistContent: PropTypes.array.isRequired,
};

export default PlaylistContentItemList;
